import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';

export default class extends Controller {
  static get targets() {
    return ['product', 'quantity', 'total', 'netweight', 'pricepergram', 'goldShare'];
  }

  setGoldShare(event){
    let goldShareField = $(event.target);
    if (goldShareField.val()=="Modifica") {
      $(this.goldShareTarget).removeClass('d-none');
      goldShareField.hide();
    } else {
      $(this.goldShareTarget).val(goldShareField.val());      
    }
    this.setCalculatedFields();
  }
  setCalculatedFields(event) {
    let quantity = +this.quantityTarget.value;
    let total = +this.totalTarget.value;
    let goldShare = null;
    if (this.hasGoldShareTarget) {
      goldShare = +this.goldShareTarget.value;
    } else {
      var productData = $(this.productTarget).data('product');
      // let selected = $(this.productTarget).find("option:selected" );
      // let productData = $(selected).data("product");
      goldShare = +productData.gold_share;
    }

    let netweight = quantity*goldShare/1000;
    let pricepergram = (netweight>0) ? total/netweight : '';
  
    $(this.netweightTarget).html(formatWeight(netweight));
    $(this.pricepergramTarget).html(formatMoneyMillis(pricepergram));

    $(this.element).find('.or-gross-weight').val(quantity);
    $(this.element).find('.or-net-weight').val(netweight);

    let usedUpdateEvent = new CustomEvent("used-update");
    window.dispatchEvent(usedUpdateEvent);
  }

  removeRow(event) {
    let usedUpdateEvent = new CustomEvent("used-update");
    window.dispatchEvent(usedUpdateEvent);
  }
}
